export const Data = [
    {
        from: "Feb 2024",
        to: "Present",
        title: "Full Stack Developer",
        company: "Plusworld Roofing Limited",
        details: `I manage the existing technical products of plusworld roofing and I am also currently building a platform where users can learn courses about real estate and construction.\n
        `,
        url: 'https://plusworld.vercel.app'
    },
    {
        from: "Oct 2023",
        to: "May 2025",
        title: "Full Stack Developer",
        company: "Afrifashion",
        details: `I independently developed and designed from scratch a fully customizable webapp to sell african fabrics`,
        url: 'https://afrifashion.vercel.app'
    },
    {
        from: "Dec 2024",
        to: "Feb 2025",
        title: "Full Stack Developer",
        company: "Audet Blog (Personal Blog)",
        details: `I independently developed and designed a fully customizable web app to upload and read music blogs`,
        url: 'https://audet.vercel.app'
    },
  
]